<template>
  <v-card>
    <v-card-title>
      <span class="headline">Сбросить пароль</span>
    </v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>

        <template v-if="data_sent">
          <v-text-field
            label="Новый пароль"
            type="password" 
            v-model="password"
            :rules="passwordRules"
            required
          />
          <v-text-field
            label="Повторите новый пароль"
            type="password" 
            v-model="password_confirm"
            :rules="passwordConfirmRules"
            required
          />
          <v-text-field
            type="number"
            min="100001"
            max="999998"
            label="Введите код подтверждения"
            v-model="verification_code"
          />

          <span v-if="count > 0">Выслать код повторно можно будет через {{ count }} сек.</span>
          <a v-else @click.prevent="sendCodeAgain">Выслать код повторно</a>
        </template>

        <template v-else>
          <v-text-field
            label="Email или телефон"
            v-model="email_phone"
            hint="Email или номер телефона для кода подтверждения сброса пароля"
            placeholder="Например, ivan@mail.ru или +7(999)123-45-67"
            :rules="emailOrPhoneRules"
            required
          />
          <v-checkbox
            label="Подтверждаю сброс пароля"
            v-model="resetAgree"
            color="light-blue darken-2"
            hint="Нужно отметить чекбокс для подтверждения сброса пароля"
            persistent-hint
            required
          />
        </template>
          
        <div class="red--text">{{ errorMessage }}</div>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="red" flat @click.native="closeDialog">Отмена</v-btn>
      <v-btn 
        color="light-blue darken-1"
        flat 
        @click.native="changePassword" 
        :disabled="!valid || resetAgree===false || (data_sent && !verification_code)"
      >
        Сохранить
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
import apiAuth from "../api"

export default {
  name: 'ResetForm',

  data() {
    return {
      email_phone: '',
      password: '',
      password_confirm: '',
      verification_code: '',
      resetAgree: false,
      data_sent: false,

      initCountValue: 59,
      count: this.initCountValue,

      errorMessage: '',

      valid: true,

      emailOrPhoneRules: [
        v => !!v || 'Необходимо ввести электронный адрес или телефон',
        // phone only:
        // v => /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(v) || 'E-mail or Phone number must be valid'
        // email only:
        // v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail or Phone number must be valid'
        // email || phone
        v => /^((\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Необходимо ввести валидный E-mail или Телефон'
      ],
      passwordRules: [
        v => !!v || 'Необходимо ввести пароль',
        v => (v && v.length >= 10 && v.length <= 16) || 'Длина пароля должна быть от 10 до 16 символов'
      ],
      passwordConfirmRules: [
        v => !!v || 'Необходимо ввести подтверждение пароля',
        v => (v === this.password) || 'Подтверждение пароля не совпадает с паролем'
      ]
    }
  },

  methods:{
    closeDialog() {
      this.$emit('close-dialog')
    },

    changePassword() {
      if (this.$refs.form.validate()) {
        // Clear error messages
        this.errorMessage = ''
        if( this.email_phone.indexOf("@") < 0 ){
          this.email_phone = this.email_phone.replace(/[^0-9]/gim,'')
        }
        if (!this.data_sent) {
          apiAuth.resetPassword({ email_phone: this.email_phone }).then( response => {
            this.makeInterval()
            this.data_sent = true
          }).catch(error => {
            this.errorMessage = error.response.data.error
          })
        } else {
          apiAuth.confirmPassword({
            email_phone: this.email_phone,
            code: parseInt(this.verification_code),
            password: this.password,
            password_confirm: this.password_confirm
          }).then( response => {
            if (localStorage) {
              localStorage.setItem("dms_auth_tokens", JSON.stringify(response))
            }
            this.$store.commit('app/account/setAuthTokens', response)
            const account_url = process.env.APP_ACCOUNT_URL || '/account'
            window.location.replace(account_url)
          }).catch(error => {
            this.errorMessage = error.response.data.error
          })
        }
      }
    },

    sendCodeAgain() {
      apiAuth.resendCode({
        email_phone: this.email_phone,
        context: 'reset'
      }).then(response => {
        this.makeInterval()
      }).catch(error => {
        console.warn(error)
      })
    },

    makeInterval() {
      this.count = this.initCountValue
      
      this.timer = setInterval(() => {
        if (this.count > 0) {
          this.count--
        } else {
          clearInterval(this.timer)
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
  .error--text{
    color: #f44336 !important;
    caret-color: #f44336 !important;
  }
</style>


// WEBPACK FOOTER //
// src/apps/auth/components/ResetForm.vue